import {setArchivedProjectList, setProjectList} from "../actions";
import Facade from "../Facade";

export default function runRefreshArchivedProjectList ( dispatch )
{
  //刷新
  Facade.gw.getArchiveProjectList((list) => {
    dispatch(setArchivedProjectList(list));
  });
}